module.exports = __webpack_public_path__ + "img/pic02.2f79e724.png";